import React, { Component } from 'react';
import ResetPassword from '../resetPassword/resetPassword';
import ConfirmationCode from '../confirmationCode/confirmationCode';
import SendEmail from '../Email/email';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button, Row, Col, Container } from 'reactstrap'
// import logo from '../../../../assets/images/logo.png';
import logo from "../../../../assets/images/Layer.png"

import { Redirect } from 'react-router-dom';
import LoadingBar from 'react-redux-loading-bar'

class ForgetPassword extends Component {
    state = {
        type: "ADMIN",
    }

    handlecheck = (values) => {
        console.log("change selector to",values)
       this.setState({type:values})

    }
    render() {
        return (
            <div>
                <div>
                <div className="loading-bar" >
                    <LoadingBar style={{ height: '3px', zIndex: 1000, backgroundColor: "#orange" }} />
                </div>
                    <div className="allViews">
                        <div className="col-lg-12 pt-3">
                            <div className="Logo text-center ">
                                <img src={logo} alt="Logo" className="img-responsive" />
                            </div>
                        </div>

                        <Container>
                            <Row>
                                <Col>
                                    <div className="stepper">
                                        <Button><span style={{ backgroundColor: this.props.pageName === 'email' ? '#115A78' : '' }}>1</span></Button>
                                        <Button><span style={{ backgroundColor: this.props.pageName === 'confirmationCode' ? '#115A78' : '' }}>2</span></Button>
                                        <Button><span style={{ backgroundColor: this.props.pageName === 'resetPassword' ? '#115A78' : '' }}>3</span></Button>
                                    </div>
                                    {this.props.pageName === 'email' && <SendEmail handlecheck={this.handlecheck}/>}
                                    {this.props.pageName === 'confirmationCode' && <ConfirmationCode type={this.state.type}/>}
                                    {this.props.pageName === 'resetPassword' && <ResetPassword type={this.state.type}/>}
                                    {this.props.pageName === 'dashboard' && <Redirect to="/Maktapti/Dashboard" />}

                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    return {
        pageName: state.forget.page
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
    }
    , dispatch
)
export default connect(mapStateToProps, mapDispatchToProps)(ForgetPassword);